var map = {
	"./Akmola_obl.png": "705b",
	"./Aktobe.png": "bd8e",
	"./Almaty.png": "7725",
	"./Almaty_obl.png": "4398",
	"./Astana.png": "5d08",
	"./Atyrau.png": "ee98",
	"./Component5.png": "0df68",
	"./Filling-the-hotel.png": "11da",
	"./Karagandy_obl.png": "650b",
	"./Kostanay.png": "9be6",
	"./Kyzylorda.png": "1c3d",
	"./MCS_Logos.png": "b0b4",
	"./MCS_Logos_ENG.png": "ae76",
	"./MCS_Logos_KAZlat.png": "cf8f",
	"./MCS_Logos_RU.png": "68d5",
	"./Mangystau.png": "d520",
	"./MaskGroup(1).png": "7d5a",
	"./MaskGroup(2).png": "0210",
	"./MaskGroup(3).png": "3b87",
	"./MaskGroup.png": "2695",
	"./Pavlodar_obl.png": "7aed",
	"./SKO.png": "0de2",
	"./Shymkent.png": "ce9d",
	"./Tourist-services.png": "643e",
	"./Turkystan.png": "fa25",
	"./VKO.png": "3517",
	"./ZKO.png": "8ebc",
	"./Zhambyl_obl.png": "b49d",
	"./about/banner.png": "8ac0",
	"./adminpanel.png": "a5f0",
	"./almaty1.jpg": "e1bc",
	"./almaty2.jpg": "335e",
	"./almaty3.jpg": "7696",
	"./almaty4.jpg": "af9d",
	"./almaty5.jpg": "7ace",
	"./almatyObl1.jpg": "fa74",
	"./almatyObl2.jpg": "45a3",
	"./almatyObl3.jpg": "d156",
	"./almatyObl4.jpg": "9776",
	"./almatyObl5.jpg": "1a9d",
	"./aqmola1.jpg": "3052",
	"./aqmola2.jpg": "2962",
	"./aqmola3.jpg": "af11",
	"./aqmola4.jpg": "14a6",
	"./aqmola5.jpg": "e583",
	"./aqtobe1.jpg": "9868",
	"./aqtobe2.jpg": "9fdb",
	"./aqtobe3.jpg": "c3a8",
	"./aqtobe4.jpg": "4d18",
	"./aqtobe5.jpg": "1543",
	"./aqtobe6.jpg": "a8eb",
	"./aqtobe7.jpg": "565f",
	"./article-1612327170.jpg": "f3d3",
	"./astana1.jpg": "469a",
	"./astana2.jpg": "c916",
	"./astana3.jpg": "71ab",
	"./astana4.jpg": "3748",
	"./astana5.jpg": "a458",
	"./atyrau.jpg": "acea",
	"./bulletin-hotel.png": "75d8",
	"./countryFlag-01.png": "de24",
	"./countryFlag-02.png": "516c",
	"./countryFlag-03.png": "0faa",
	"./countryFlag-04.png": "7545",
	"./countryFlag-05.png": "b5c8",
	"./digest.svg": "d0dc",
	"./digest1.svg": "3d7e",
	"./digest_main_image.svg": "8212",
	"./gov_logo.png": "69eb",
	"./home/journey.png": "42cc",
	"./home/map-point.png": "fcaf",
	"./home/map.png": "6644",
	"./home/plane.png": "296e",
	"./hotelLogo-01.png": "f683",
	"./hotelLogo-02.png": "b6c5",
	"./hotelLogo-03.png": "2522",
	"./hotelLogo-04.png": "b975",
	"./hotelLogo-05.png": "cf5a",
	"./icon--arrow-down.svg": "a592",
	"./image--about-system.svg": "e6ba",
	"./image--header.svg": "dff0",
	"./jambyl1.jpg": "ee32",
	"./jambyl2.jpg": "be79",
	"./jambyl3.jpg": "66f2",
	"./jambyl4.jpg": "bb88",
	"./jambyl5.jpg": "09bb",
	"./jambyl6.jpg": "6fe4",
	"./jambyl7.jpg": "0adf",
	"./karagandy1.jpg": "c708",
	"./karagandy2.jpg": "1dc2",
	"./karagandy3.jpg": "1bec",
	"./karagandy4.jpg": "e068",
	"./karagandy5.jpg": "fbb8",
	"./karagandy6.jpg": "39ed",
	"./kazakh_tourism.png": "3894",
	"./logo.png": "9d64",
	"./main.svg": "76cf",
	"./mang1.jpg": "9a49",
	"./mang2.jpg": "9a58",
	"./mang3.jpg": "eaec",
	"./mang4.jpg": "36c6",
	"./pavl1.jpg": "5c99",
	"./pavl2.jpg": "f59c",
	"./pavl3.jpg": "e070",
	"./pavl4.jpg": "ff27",
	"./pavl5.jpg": "77ca",
	"./qostanay1.jpg": "1147",
	"./qostanay2.jpg": "9087",
	"./qostanay3.jpg": "86f4",
	"./qostanay4.jpg": "e83e",
	"./regions/Абай облысы.png": "2da0",
	"./regions/Алматы облысы.png": "1a56",
	"./regions/Алматы қ..png": "4243",
	"./regions/Астана қ..png": "511f",
	"./regions/Атырау облысы.png": "71ac",
	"./regions/Ақмола облысы.png": "6448",
	"./regions/Ақтөбе облысы.png": "52eb",
	"./regions/Батыс Қазақстан облысы.png": "b253",
	"./regions/Жамбыл облысы.png": "6052",
	"./regions/Жетісу облысы.png": "c316",
	"./regions/Маңғыстау облысы.png": "aabc",
	"./regions/Оңтүстік Қазақстан облысы.png": "09d8",
	"./regions/Павлодар облысы.png": "1f99",
	"./regions/Солтүстік Қазақстан облысы.png": "d420",
	"./regions/Түркістан облысы.png": "35da",
	"./regions/Шымкент қ..png": "1f41",
	"./regions/Шығыс Қазақстан облысы.png": "08d7",
	"./regions/Қарағанды облысы.png": "9739",
	"./regions/Қостанай облысы.png": "275a",
	"./regions/Қызылорда облысы.png": "fd68",
	"./regions/Ұлытау облысы.png": "24aa",
	"./shymkent1.jpg": "37f0",
	"./shymkent2.jpeg": "1b77",
	"./shymkent3.jpg": "057f",
	"./shymkent4.jpg": "4fb9",
	"./sko.jpg": "5068",
	"./turk1.jpg": "8eb0",
	"./turk2.jpg": "2cc0",
	"./turk3.jpg": "ca6d",
	"./turk4.jpg": "bbd0",
	"./turk5.jpg": "4069",
	"./vko1.jpg": "876f",
	"./vko2.jpg": "3867",
	"./vko3.jpg": "5e76",
	"./vko4.jpg": "5f7f",
	"./vko5.jpg": "18ce",
	"./zko1.jpg": "691f",
	"./zko2.jpg": "a2e0",
	"./zko3.jpg": "8aa2",
	"./zko4.jpg": "e819",
	"./zko5.jpg": "87af",
	"./zko6.jpg": "6ca1",
	"./zko7.jpg": "885e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";